export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";